import { classBuilderI18n } from './class-builder.i18n';
import { preferencesI18n } from './preferences.i18n';
import { staffI18n } from './staff.i18n';
import { storageAdminI18n } from './storage-admin.i18n';
import {studentI18n} from './student.i18n';
import {substituteTeacherI18n} from './substitute-teacher.i18n';

export const toolsI18n = {
  en: {
    institutionInfo: {
      name: 'Institution name',
      address: 'Institution Address',
      phoneNumber: 'Phone Number',
      webSite: 'Website Address',
      state: 'State/Province',
      city: 'City',
      country: 'Country',
      zipCode: 'Zip/Postal Code',
      firstName: 'First Name',
      LastName: 'Last Name',
      email: 'Email',
      schoolDA: 'School District Admins',
      schoolDASubtitle: 'School District Admins are those who manage a School District',
      chooseInstitution: 'Choose an Institution',
      chooseCountry: 'Choose a country',
      chooseCity: 'Choose a city',
      registerTitle: 'Register',
      errorZipCodeBody: 'Zip Code not found',
      successChanges: 'The changes were saved succesfully',
      unSuccesChanges: 'There was an error on saving',
      errorGettingInfo: 'There was an error trying to get the information'
    },
    toolbar: {
      myInfo : 'My Info',
      institutionInformation : 'Institution Information',
      schoolCalendarAdmin : 'School Calendar Admin',
      courseAdmin : 'Subject Admin',
      departmentAdmin : 'Department Admin',
      familyAdmin : 'Family Admin',
      licenseAdmin : 'License Admin',
      schoolAdmin : 'School Admin',
      staffAdmin : 'Staff Admin',
      storageAdmin : 'Storage Admin',
      studentAdmin : 'Student Admin',
      websiteAdmin : 'Website Admin',
      synchronization : 'Synchronization Admin',
      classAdmin: 'Class Admin',
      preferences: 'Preferences',
      substituteTeacher: 'Substitute Teachers Admin',
    },
    schooldays: {
      holiday: 'Holiday',
      holidays: 'Holidays',
      offDay: 'Day off',
      offDays: 'Days off',
      business: 'Business day',
      event: 'Event',
      events: 'Events',
      createModalTitle: 'Edit date',
      dayTypeLabel: 'Mark day as',
      firstDay: 'First day',
      lastDay: 'Last day',
      today: 'Today',
      unspecified: 'Unspecified',
      periodName: 'Period school name',
      setDate: 'Day',
      setSchoolCalendar: 'School Calendar Period',
      startAt: 'Start at',
      endAt: 'End at',
      schoolCalendarTitle: 'School District Calendar',
      workingDays: 'School Days',
      configWorkingDaysTitle: 'Set school days',
      disclamerCreate: 'To create a new Event or School Calendar, you only have to click on a date.',
      disclamerEdit: 'To edit an Event, you only have to click on the event color.',
      confirmRemoveDate: 'Are you sure that you want to remove this date?',
      usHolidays: 'United States holidays',
      schoolDay: 'School day',
      dayOffWarning: 'Note: If there are assignments created in the selected date in any subject, they are going to move to the next school day.',
      showNonSchoolDays: 'Show non school days',
      errors: {
        errorSavingDateTitle: 'Ops!',
        errorSavingDateMsg: 'Sorry, there was an error editing the selected date. Try again',
        errorSavingWorkingDaysMsg: 'Sorry, there was an error editing the school days. Try again',
        errorLoadingCalendarMsg: 'Sorry, we can\'t load the school district calendar. Try again',
        errorTryCreate: 'Sorry, you cannot create or edit an event on an earlier date',
        errorSavingColor: 'Sorry, there was an error saving color. Try again',
        errorSavingDayOff: 'Sorry, you cannot add more than one day off to a day.',
        errorSavingEvent: 'Sorry, you cannot add more than one event to a day.'
      }
    },
    myInfo: {
      userInformation: 'User information',
      errorZipCodeBody: 'Zip Code not found',
      emailAlreadyExists: 'Email {email} already exists',
      reviewInfo: 'Check information',
      unSuccessChanges: 'There was an error on saving',
      successChanges: 'The changes were saved succesfully',
      phoneVerification: 'Phone verification',
      recentActivity: 'Recent activity',
      calendar: {
        title: 'My calendars',
        clientUrl: 'Calendar URL',
        error: 'Sorry, there was an error saving the calendar. Try again',
        errorLoading: 'Sorry, an error occurred trying to load the calendars. Please try again.',
        accessRead: 'Read',
        accessWrite: 'Read & Write',
        updatePassword: 'Update password',
        copyPassword: 'Copy password to clipboard',
        copyUsername: 'Copy username to clipboard',
        copyUrl: 'Copy url to clipboard',
        cols: {
          name: 'Name',
          type: 'Type',
          username: 'Username',
          password: 'Password',
          access: 'Type of access'
        }
      }
    },
    synchronization: {
      title: 'Synchronization Admin',
      sectionCourseFileTitle: 'Subject files',
      sectionCourseFileColumnCourse: 'Subject',
      sectionCourseFileColumnFiles: 'Local / Files',
      sectionCourseFileColumnSync: 'Sync %',
      msgNoCoursesAvailable: 'No subjects available',
      msgSynchronizationCourseLoading: 'Loading subject {contentTitle} ...',
      msgSynchronizationDone: 'Synchronization done for {courseCount} subjects.',
      msgSynchronizationResource: 'Downloading file {resourceCounter} from object: <b>{resourceName}</b>',
      msgSynchronizationErrorNoMoreLocalSpace: 'You have no more local space available for downloading files.',
      msgSynchronizationErrorGeneral: 'Unexpected error'
    },
    preferences: preferencesI18n.en,
    staff: staffI18n.en,
    student: studentI18n.en,
    recentActivity: {
      title: 'Recent Activity',
      ip: 'Ip',
      date: 'Date',
      country: 'Country',
      region: 'Region',
      city: 'City',
      systemInformation: 'System Information',
      browser: 'Browser',
      goBack: 'Go Back'
    },
    substituteTeacher: substituteTeacherI18n.en,
    errors: {
      notOrganization: 'Sorry, You can\'t to make any action here, because you don\'t have any organization assigned.',
      notPermissions: 'Sorry, You don\'t have permission to view this option'
    },
    classBuilder: classBuilderI18n.en,
    storageAdmin: storageAdminI18n.en
  },
  es: {
    institutionInfo: {
      name: 'Nombre de la institución',
      address: 'Dirección de la institución',
      phoneNumber: 'Número de teléfono',
      webSite: 'Sitio web',
      state: 'Estado/Provincia',
      city: 'Ciudad',
      country: 'País',
      zipCode: 'Código Postal',
      firstName: 'Nombre',
      LastName: 'Apellidos',
      email: 'Correo electrónico',
      schoolDA: 'Admins de Distrito Escolar',
      schoolDASubtitle: 'Los Admins de Distrito Escolar son aquellos que gestionan un Distrito Escolar',
      chooseInstitution: 'Selecciona una institución',
      chooseCountry: 'Selecciona un país',
      chooseCity: 'Selecciona una ciudad',
      registerTitle: 'Registro',
      errorZipCodeBody: 'No se encontró el código postal',
      successChanges: 'Los cambios del formulario se guardarón correctamente',
      unSuccesChanges: 'Se produjo un error al guardar los cambios',
      errorGettingInfo: 'Hubo un error tratando de obtener la información'
    },
    toolbar: {
      myInfo : 'Mi Info',
      institutionInformation : 'Información de Institución',
      schoolCalendarAdmin : 'Admin del calendario escolar',
      courseAdmin : 'Admin de curso',
      departmentAdmin : 'Admin de departamento',
      familyAdmin : 'Admin de familia',
      licenseAdmin : 'Admin de licencia',
      schoolAdmin : 'Admin de escuela',
      staffAdmin : 'Admin de personal',
      storageAdmin : 'Admin de almacenamiento',
      studentAdmin : 'Admin de estudiante',
      websiteAdmin : 'Admin de sitio web',
      synchronization : 'Admin de sincronización',
      classAdmin: 'Admin de clases',
      preferences: 'Preferencias',
      substituteTeacher: 'Admin de Profesores sustitutos'
    },
    schooldays: {
      holiday: 'Festivo',
      holidays: 'Festivos',
      offDay: 'Día libre',
      offDays: 'Días libres',
      business: 'Día escolar',
      event: 'Evento',
      events: 'Eventos',
      createModalTitle: 'Editar fecha',
      dayTypeLabel: 'Marcar esta fecha como',
      firstDay: 'Primer día',
      lastDay: 'Último día',
      today: 'Hoy',
      unspecified: 'Sin especificar',
      periodName: 'Nombre del período escolar',
      setDate: 'Día',
      setSchoolCalendar: 'Período de calendario escolar',
      startAt: 'Inicia en',
      endAt: 'Finaliza en',
      schoolCalendarTitle: 'Calendario Escolar',
      workingDays: 'Días escolares',
      configWorkingDaysTitle: 'Configurar días escolares',
      disclamerCreate: 'Para crear un nuevo Evento o Calendario escolar solo debes hacer click en la fecha deseada.',
      disclamerEdit: 'Para editar un Evento, solo debes hacer clic en el color del evento.',
      confirmRemoveDate: '¿Está usted seguro que desea eliminar esta fecha?',
      usHolidays: 'Festivos en Estados Unidos',
      schoolDay: 'Día de escuela',
      dayOffWarning: 'Nota: Si hay tareas creadas en la fecha seleccionada de cualquier curso, estas serán movidas al día escolar siguiente.',
      showNonSchoolDays: 'Mostrar días no escolares',
      errors: {
        errorSavingDateTitle: 'Ops!',
        errorSavingDateMsg: 'Lo sentimos, ocurrió un error editando la fecha seleccionada. Por favor intenta de nuevo.',
        errorSavingWorkingDaysMsg: 'Lo sentimos, ocurrió un error editando los días escolares. Por favor intenta de nuevo.',
        errorLoadingCalendarMsg: 'Lo sentimos, ocurrió un error intentando cargar el calendario escolar. Por favor intenta de nuevo.',
        errorTryCreate: 'Lo sentimos, no es posible crear o editar un evento en una fecha anterior.',
        errorSavingColor: 'Lo sentimos, ocurrió un error guardando el color. Por favor intenta de nuevo.',
        errorSavingDayOff: 'Lo sentimos, solo puede agregar un día libre en cada fecha.',
        errorSavingEvent: 'Lo sentimos, solo puede agregar un evento en cada fecha.'
      }
    },
    myInfo: {
      userInformation: 'Información de usuario',
      errorZipCodeBody: 'No se encontró el código postal',
      emailAlreadyExists: 'Correo electronico {email} ya existe',
      reviewInfo: 'Revisar información',
      successChanges: 'Los cambios del formulario se guardarón correctamente',
      unSuccessChanges: 'Se produjo un error al guardar los cambios',
      phoneVerification: 'Validación de teléfono',
      recentActivity: 'Actividad reciente',
      calendar: {
        title: 'Mis calendarios',
        error: 'Lo sentimos, ocurrió un error guardando el calendario. Por favor intenta de nuevo.',
        clientUrl: 'URL del calendario',
        errorLoading: 'Lo sentimos, ocurrió un error intentando cargar los calendarios. Por favor intenta de nuevo.',
        accessRead: 'Leer',
        accessWrite: 'Leer & Escribir',
        updatePassword: 'Actualizar la contraseña',
        copyPassword: 'Copiar la contraseña al portapapeles',
        copyUsername: 'Copiar el nombre de usuario al portapapeles',
        copyUrl: 'Copiar el nombre de usuario al portapapeles',
        cols: {
          name: 'Nombre',
          type: 'Tipo',
          username: 'Nombre de usuario',
          password: 'Contraseña',
          access: 'Tipo de acceso'
        }
      }
    },
    synchronization: {
      title: 'Admin de sincronización',
      sectionCourseFileTitle: 'Archivos de los cursos',
      sectionCourseFileColumnCourse: 'Curso',
      sectionCourseFileColumnFiles: 'Local/Archivos',
      sectionCourseFileColumnSync: 'Sinc %',
      msgNoCoursesAvailable: 'No hay cursos disponibles.',
      msgSynchronizationCourseLoading: 'Procesando el curso {contentTitle} ...',
      msgSynchronizationDone: 'Termina la sincronización para {courseCount} cursos.',
      msgSynchronizationResource: 'Descargando archivo {resourceCounter} del objeto: <b>{resourceName}</b>',
      msgSynchronizationErrorNoMoreLocalSpace: 'No cuentas con mas espacio para guardar archivos localmente.',
      msgSynchronizationErrorGeneral: 'Se ha producido un error',
    },
    preferences: preferencesI18n.es,
    staff: staffI18n.es,
    student: studentI18n.es,
    recentActivity: {
      title: 'Actividad Reciente',
      ip: 'Ip',
      date: 'Fecha',
      country: 'Pais',
      region: 'Departamento',
      city: 'Ciudad',
      systemInformation: 'Información del sistema',
      browser: 'Navegador',
      goBack: 'Ir atras'
    },
    substituteTeacher: substituteTeacherI18n.es,
    errors: {
      notOrganization: 'Lo sentimos, No puedes ejecutar acciones aquí, ya que no tienes organizaciones asignadas',
      notPermissions: 'Lo sentimos, No tienes permisos para ingresar a estas opciones.'
    },
    classBuilder: classBuilderI18n.es,
    storageAdmin: storageAdminI18n.es
  }
}
